import type { FaireProductEntity } from "../../entity_types/product";

export const p_r4qt2uprvh: FaireProductEntity = {
  token: "p_r4qt2uprvh",
  type: "product",
  name: "Gianna Ribbed Up Tunic Cardigan",
  brandToken: "b_aikxxfpecb",
  brandName: "Threaded Pear",
  imageUrl:
    "https://cdn.faire.com/fastly/ccfa37f3f064e50a0bd085caf9bc3396be3d751b446c4c77c9f175d0b6559e6b.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/34f2ac9913e9d105bf4b6f7c9bfc55ff6bedddc21e2b34358a78d1d8ffe0ae21.jpeg",
    "https://cdn.faire.com/fastly/34108d41987a7c9f97b27579a7131892ea79af671b6cbe1f22420dd66f0ca02b.jpeg",
    "https://cdn.faire.com/fastly/f6409b1ff36f573f442092c1824b5d6ea5f21fd990dcb22fcd611970d5616362.jpeg",
    "https://cdn.faire.com/fastly/951cbe4bffea67f05749d0bcb8aefed6f2ea560379df43b74185c2d00910bd26.jpeg",
    "https://cdn.faire.com/fastly/b669ceae0b5e25ab6ab768500f680fc86e33cd753da1f25648f7f10be7516ba6.jpeg",
    "https://cdn.faire.com/fastly/dce863db6ddbe67a543eb1b0f053abe3ac95d8d7c5faba3f7a50cf765d17e22d.jpeg",
    "https://cdn.faire.com/fastly/96b7bd532462002abfddb6ede54a1d82d398726ddbfc25a7fb87ed6801d0941f.jpeg",
    "https://cdn.faire.com/fastly/164936d7ba9bc9988285630afccff0a18f523eb9ec08fb76907a30400cf9a1d6.jpeg",
    "https://cdn.faire.com/fastly/dfd6d27de68767d10ec8114ae25159bf4e7ef7bae3844619ac2eca71fe5336f1.jpeg",
    "https://cdn.faire.com/fastly/31517c68822137e41a24b4aa6857c1385be08ea8565ac82c5fdc60344022449c.jpeg",
    "https://cdn.faire.com/fastly/220dc0b82497c2d1db201ebd3b88507744095716763939153ad5cebb4dced37b.jpeg",
    "https://cdn.faire.com/fastly/ba956a69b4587c5597ed5e0ac7c99e151f5785d03fd33d3285c1c267fbdbe7ec.jpeg",
    "https://cdn.faire.com/fastly/8001d1e279e6103acb08c5e2d63967abea2697240647b075885defa291a07a6e.jpeg",
    "https://cdn.faire.com/fastly/6af5f76ba1b4abd597b79734e619d093336a1af932a14047d80a23f1abebed8f.jpeg",
    "https://cdn.faire.com/fastly/beee885a5e86d8131a1bb33e8a3a287b4ff6e7a9c18ad9a1f0a53b06297a56bf.png",
  ],
  priceDollars: 25.19,
  description:
    "Say hello to Gianna Ribbed Up Tunic Cardigan—effortless, everyday style with comfort built in. Elevate your look with the timeless rib knit design, adding texture and depth to your outfit. Versatile and easy to style, the solid color of this cardigan makes it a versatile piece. Achieve a polished and put-together look with the button-up front. The flattering tunic length provides added coverage and a sophisticated silhouette. Material: 48%Viscose+25%Polyester+17%Polyamide+10%Metallized Fibres.",
  tags: [],
  msrpDollars: 41.99,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-25T20:53:17.241Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
